export const getBrandsMenuItems = ({ page, isBrandPage, isBrandsPage, isNewBrandPage }) => {
  const menuGroup = []

  menuGroup.push({
    img: 'brands',
    title: 'Brands',
    href: `/brands`,
    active: isBrandsPage || isNewBrandPage || (isBrandPage && page !== ''),
    visible: true,
  })

  return menuGroup
}
